/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { InsightsPanelModule } from '@fleetmatics/ui.insights-panel';
import { environment } from '../../environments/environment';
import { SidePanelLargeComponent } from './components';
import { SidePanelSmallComponent } from './components/side-panel-small/side-panel-small.component';
import { OverlaySidePanelComponent } from './containers';

@NgModule({
  declarations: [SidePanelLargeComponent, OverlaySidePanelComponent, SidePanelSmallComponent],
  imports: [CommonModule, MatIconModule, InsightsPanelModule.forRoot(environment.config)],
  exports: [OverlaySidePanelComponent, SidePanelLargeComponent, SidePanelSmallComponent]
})
export class SidePanelModule {}
